import React from 'react';
import styled from 'styled-components';
import { ApButtonMain } from '@alixpartners/ui-components';
import CheckboxGroupUnstyled from 'components/CheckboxGroup';
import { Bar } from 'components/CheckboxGroup/styles';
import { colors } from '@alixpartners/ui-components';

export const SectionSubtitle = styled.div`
	color: ${colors.grey5};
	font-size: 13px;
	line-height: 19px;
	text-align: center;
	letter-spacing: 0.3px;
	padding-bottom: 40px;
`;

export const StepFooter = styled.div`
	padding-top: 17px;
	display: flex;
`;

export const ButtonMain = styled(ApButtonMain)`
	margin-left: auto;
`;

export const CheckboxGroup = styled(CheckboxGroupUnstyled)`
	padding-bottom: 15px;

	${Bar} {
		padding: 6px;
		min-height: 28px;
		padding-left: 0;
		margin-left: -1px;
	}
`;

export const Row = styled.div`
	display: flex;
	margin-top: 8px;
`;

export const ColumnTitle = styled.div`
	color: ${colors.grey5};
	font-size: 11px;
	letter-spacing: 0.8px;
	line-height: 13px;
	text-transform: uppercase;
	margin-bottom: 2px;
	width: calc(40% - 42px);
	padding-left: 40px;
	& + & {
		width: 60%;
		padding-left: 0;
	}
`;

export const ColumnItem = styled.div`
	color: ${colors.grey7};
	font-size: 16px;
	text-transform: uppercase;
	width: calc(40% - 42px);
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;

	svg {
		margin-right: 17px;
	}

	span {
		display: block;
		overflow: hidden;
		text-overflow: ellipsis;
	}
`;

export const LoaderText = styled(({ className }) => (
	<span className={className}>Loading columns...</span>
))`
	font-size: 13px;
	font-weight: 400;
	letter-spacing: normal;
	text-align: center;
`;

export const LoaderContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	height: 100%;
	width: 100%;
	min-height: 400px;
`;
